/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from "react";
import {useDispatch, connect} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import {login} from "../_redux/authActions";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import {useFormik} from "formik";
import * as Yup from "yup";
import {FormattedMessage, injectIntl} from "react-intl";
import * as auth from "../_redux/authRedux";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

const initialValues = {
  username: "",
  password: ""
};

export function AuthPage(props) {
  const history = useHistory();
  const location = useLocation();
  if (location.pathname !== "/") history.replace("/");

  const {intl} = props;
  const usernamePlaceholder = intl.formatMessage({id: 'auth-username-label'});
  const passwordPlaceholder = intl.formatMessage({id: 'auth-password-label'});

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const enableLoading = () => setLoading(true);
  const disableLoading = () => setLoading(false);

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setStatus(undefined);
      enableLoading();
      setTimeout(() => {
        Promise
          .resolve()
          .then(() => {
            const {username, password} = values;
            return dispatch(login({username, password}));
          })
          .then(() => {
            disableLoading();
            logUserAction(
              P.AUTH,
              S.SYSTEM_ACCESS,
              T.CREATE,
              L.LOGIN(values.username),
              0
            );
          })
          .catch(() => {
            disableLoading();
            setSubmitting(false);
            setStatus(
              intl.formatMessage({
                id: "AUTH.VALIDATION.INVALID_LOGIN",
              })
            );
          });
      }, 1000);
    },
  });

  return (
    <div
      className="login login-5 login-signin-on d-flex flex-row-fluid"
      id="kt_login"
    >
      <div
        className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
        style={{backgroundImage: 'url(media/bg/bg-2.jpg)'}}
      >
        <div
          className="login-form text-center text-white p-7 position-relative overflow-hidden">
          <div className="d-flex flex-center mb-15">
            <img
              src={toAbsoluteUrl("/media/atzmai/logo.png")}
              className="w-50"
              alt="logo"
            />
          </div>
          <div className="login-signin">
            <div className="mb-20">
              <h3 className="opacity-40 font-weight-normal">
                <FormattedMessage id="AUTH.LOGIN.TITLE"/>
              </h3>
              <p className="opacity-40">
                <FormattedMessage id="auth-form-title"/>
              </p>
            </div>
            <form
              className="form"
              id="kt_login_signin_form"
              onSubmit={formik.handleSubmit}
            >
              <div className="form-group">
                <input
                  className="form-control h-auto text-white bg-white-o-5 rounded-pill border-0 py-4 px-8"
                  type="text" placeholder={usernamePlaceholder} name="username"
                  {...formik.getFieldProps("username")}
                  autoComplete="off"/>
              </div>
              <div className="form-group">
                <input
                  className="form-control h-auto text-white bg-white-o-5 rounded-pill border-0 py-4 px-8"
                  type="password" placeholder={passwordPlaceholder}
                  name="password"
                  {...formik.getFieldProps("password")}
                />
              </div>
              <div className="form-group text-center mt-10">
                <button id="kt_login_signin_submit"
                        className="btn btn-pill btn-primary opacity-90 px-15 py-3">
                  <FormattedMessage
                    id="auth-login-btn"
                    defaultMessage="Sign in"
                  />
                </button>
                {loading && <span className="spinner spinner-white" />}
              </div>
              {formik.status &&
              <div className="alert alert-danger mb-10">{formik.status}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

const connectedAuthPage = connect(null, auth.actions)(AuthPage);
export default injectIntl(connectedAuthPage);
